import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { TListingMode } from '~/types/cluster'

import ListIconBlack from '~/assets/cluster-details-list-icon--black.png'
import ListIconWhite from '~/assets/cluster-details-list-icon--white.png'
import PlusIconBlack from '~/assets/cluster-details-plus-icon--black.png'
import PlusIconWhite from '~/assets/cluster-details-plus-icon--white.png'
import { useClustersContext } from '~/providers/Clusters'
import { useSearchParamsContext } from '~/providers/SearchParams'

import './styles.scss'

const listingButtons: { activeIconSrc: string; defaultIconSrc: string; id: TListingMode; label: string }[] = [
  { activeIconSrc: ListIconWhite, defaultIconSrc: ListIconBlack, id: 'cluster', label: 'Apps Listing' },
  { activeIconSrc: PlusIconWhite, defaultIconSrc: PlusIconBlack, id: 'candidates', label: 'Explore new candidates' },
]

const ListingModeSwitchButton = (): ReactElement => {
  /** Local state */

  const { dispatch: dispatchToClustersContext, state } = useClustersContext()

  const { listingMode } = state

  const { dispatchToSearchParams } = useSearchParamsContext()

  /** Handlers */

  const handleButtonClick = (value: TListingMode) => () => {
    dispatchToClustersContext({ type: 'listingMode', value })
    dispatchToSearchParams({ type: 'update', value: { listingMode: value } })
  }

  /** Render */

  return (
    <div className="listing-mode-switch-button">
      {listingButtons.map(({ activeIconSrc, defaultIconSrc, id, label }) => (
        <button
          className={classNames('listing-mode-switch-button__button', {
            'listing-mode-switch-button__button--active': listingMode === id,
          })}
          id={id}
          key={id}
          onClick={handleButtonClick(id)}
        >
          <img
            alt=""
            className="listing-mode-switch-button__button__icon"
            src={listingMode === id ? activeIconSrc : defaultIconSrc}
          />
          {label}
        </button>
      ))}
    </div>
  )
}

export default ListingModeSwitchButton
